<template>
  <router-view/>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Slab&family=Roboto:wght@300;400;700&display=swap');

#app {
  font-family: Roboto, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

h1 {
  font-family: Roboto Slab, serif;
  font-size: 3.5rem !important;
  font-style: normal;
  font-weight: 700;
  line-height: 71px;
  letter-spacing: 0em;
}

h2 {
  font-family: Roboto Slab, serif;
  font-size: 2.5rem !important;
  font-style: normal;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 0em;
}

h3 {
  font-family: Roboto Slab, serif;
  color: #F2893E;
}

h4 {
  color: #738D28;
  font-size: 1.25rem;
}

/* .main-content {
  max-width: 1440px;
  margin: auto;
} */

.fit-width {
  width: 100vw;
  margin-left: calc((100% - 100vw)/2);
  padding-left: calc(((100% - 100vw)/2)*-0.3);
  padding-right: calc(((100% - 100vw)/2)*-0.3);
}

p {
  /* font-size: 24px; */
  font-size: 1.2rem;
}

.title-content {
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 1200px) {
  .title-content {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}

@media (max-width: 998px) {
  h1 {
    font-size: 1.5rem !important;
    line-height: 40px;
  }

  h2 {
  font-size: 1rem !important;
  line-height: 25px;
}
}
</style>
